import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=32e08a6c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=32e08a6c&prod&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=32e08a6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e08a6c",
  null
  
)

export default component.exports